import React, { useState } from "react";
import "./Feedback.css";
import awlLogo from "./awl-logo.png";
import confetti from "canvas-confetti";

export default function Feedback() {
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState(null);

  const emojiRatings = [
    { emoji: "😡", label: "Frustrated" },
    { emoji: "😐", label: "It's Okay" },
    { emoji: "😊", label: "Good" },
    { emoji: "🤩", label: "Excellent!" },
  ];
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim() || !description.trim()) {
      alert("Please fill in both Subject and Description fields.");
      return;
    }

    console.log("Submitting Feedback:", { subject, description, file });
    setShowModal(true);
    confetti({ particleCount: 150, spread: 90, origin: { y: 0.6 } });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  return (
    <div>
      <div className="app-header">
        <h1 className="app-name-header">
          insight<span className="app-name-highlight">360</span>
        </h1>
        <img src={awlLogo} alt="AWL Logo" className="company-logo-header" />
      </div>

      <div className="main-content feedback-page">
        <div className="feedback-intro">
          <h2 className="page-title">Share Your Feedback</h2>
          <p className="page-subtitle">
            Help us improve. Your thoughts and ideas are valuable to us!
          </p>
        </div>

        <form className="card" onSubmit={handleSubmit}>
          <div className="form-group emoji-group">
            <label>How are you feeling about the app?</label>
            <div className="emoji-rating">
              {emojiRatings.map((rating, index) => (
                <button
                  type="button"
                  key={rating.label}
                  className={`emoji-btn ${
                    selectedEmoji === index ? "selected" : ""
                  }`}
                  onClick={() => setSelectedEmoji(index)}
                >
                  {rating.emoji}
                </button>
              ))}
            </div>
            {selectedEmoji !== null && (
              <p className="emoji-label">{emojiRatings[selectedEmoji].label}</p>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              placeholder="e.g., App performance, User journey..."
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              rows="5"
              placeholder="Enter the details..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="attachments">Attachments</label>
            <p className="attachment-info">
              Supported file types are images and PDFs.
            </p>
            <label htmlFor="file-upload" className="upload-btn">
              {file ? `✔️ ${file.name}` : "Click to upload a file"}
            </label>
            <input
              type="file"
              id="file-upload"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>

          <button type="submit" className="submit-btn">
            Submit Feedback
          </button>
        </form>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button
              className="close-modal-btn"
              onClick={() => setShowModal(false)}
            >
              &times;
            </button>
            <h2>Thank You! 🎉</h2>
            <p>You just made the app better for everyone.</p>
            <button className="btn-primary" onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
